import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-slate-50" data-id="element-295" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-296" data-mp="cn7soxye8i0x">
        <div className="text-center mb-16" data-id="element-297" data-mp="cm51eox5sdkh">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-blue-950" data-id="element-298" data-mp="7qhc89iofkez">
            📚 THE 6-IN-1 VISUAL OLYMPIC WEIGHTLIFTING SYSTEM
          </h2>
          <p className="text-xl text-blue-950/75" data-id="element-299" data-mp="3c3mge6p356ub">
            <span className="text-amber-600 font-semibold" data-id="element-300" data-mp="3c57da2yvh1vc">150 Ready-to-Coach Sessions</span> ·
            Beginner to Advanced · Visual Technique Resources · Nothing to Build From Scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-301" data-mp="3l2zr12oy41gm">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-amber-500 shadow-lg shadow-blue-700/15' : 'border-amber-500/40 shadow-sm shadow-blue-700/10'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-302" data-mp="2xcx2gwk8pdmr" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-amber-500 text-blue-950 font-bold text-xs py-1 px-10 rotate-45 shadow" data-id="element-303" data-mp="1vfh9n25oack0">
                  ⭐ MOST POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-304" data-mp="24gxcmou5rce7">
                <span className="text-4xl" aria-hidden="true" data-id="element-305" data-mp="24eb4oo3cuuvg">
                  {volume.icon}
                </span>
                <div data-id="element-306" data-mp="3fvklt3z0hatl">
                  <div className="text-blue-700 font-bold text-sm uppercase tracking-wider" data-id="element-307" data-mp="3fut2ariov3jo">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-blue-950" data-id="element-308" data-mp="1gsxa840w8bbv">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-blue-950/75 font-medium mb-6 italic border-l-2 border-amber-500 pl-4" data-id="element-309" data-mp="1ppeo3f0n6nbb">
                {volume.subtitle}
              </p>

              <div className="mb-6 space-y-2" data-id="element-310" data-mp="x3va4ponn9sn">
                <h4 className="text-sm font-serif font-bold text-slate-500 uppercase tracking-wider mb-2" data-id="element-311" data-mp="x0qumw5qormo">
                  What does this solve for your coaching?
                </h4>
                {volume.problem.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-312" data-mp="121oedd6edtqa">
                    {paragraph}
                  </p>)}
                {volume.chains?.map(chain => <div key={chain.steps} className="pt-1" data-id="element-313" data-mp="9c7rev1jr51g">
                    {chain.label && <p className="text-blue-950 font-semibold text-sm mb-1.5" data-id="element-314" data-mp="2kzjkzt6kmv1t">{chain.label}</p>}
                    <p className="text-blue-700 font-bold text-sm bg-slate-50 border border-blue-700/20 rounded-lg px-3 py-2 uppercase" data-id="element-315" data-mp="2psvvz0ibv3c3">
                      {chain.steps}
                    </p>
                  </div>)}
                {volume.afterChain?.map(paragraph => <p key={paragraph} className="text-blue-950 font-semibold text-sm leading-relaxed" data-id="element-316" data-mp="34p3hc45h2asy">
                    {paragraph}
                  </p>)}
              </div>

              <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-317" data-mp="2upmctq1yi2yk">{volume.bulletsIntro}</p>

              <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-318" data-mp="2zo7c9n9dwily">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-319" data-mp="23ks6djy28e7b">
                    <CheckCircle2 size={18} className="text-amber-500 shrink-0 mt-0.5" data-id="element-320" data-mp="1ysqjz576h73k" />
                    <span className="text-slate-700 text-sm" data-id="element-321" data-mp="1urf3bp6a7w7i">{bullet}</span>
                  </li>)}
              </ul>

              {volume.extraList && <div className="mb-6" data-id="element-322" data-mp="1pqhfavylc7y3">
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-323" data-mp="2mj4gb7wsps3y">{volume.extraList.label}</p>
                  <ChipList items={volume.extraList.items} tone="neutral" data-id="element-324" data-mp="2igznuci331iw" />
                </div>}

              <div className="mb-6 flex-grow" data-id="element-325" data-mp="2dh3m6jwuzm6i">
                <p className="text-sm font-serif font-bold text-slate-500 uppercase tracking-wider mb-3" data-id="element-326" data-mp="2djzjc60vu6tw">
                  Visual focus:
                </p>
                <ChipList items={volume.visualFocus} tone="accent" data-id="element-327" data-mp="123sotlvin75v" />
              </div>

              <div className="bg-slate-50 border border-amber-500/40 rounded-xl p-4 mt-auto" data-id="element-328" data-mp="x2v87dq5ml6h">
                <span className="text-blue-950 font-bold block mb-1" data-id="element-329" data-mp="n111upj4ltnj">Result:</span>
                {volume.result.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm" data-id="element-330" data-mp="rzcet94pwk9z">
                    {paragraph}
                  </p>)}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function ChipList({
  items,
  tone
}: {
  items: string[];
  tone: 'accent' | 'neutral';
}) {
  const chipClass = tone === 'accent' ? 'bg-blue-950 text-amber-500' : 'bg-slate-50 text-blue-950 border border-blue-700/20';
  return <ul className="flex flex-wrap gap-2" data-id="element-331" data-mp="1fp6m7b69pgmu">
      {items.map(item => <li key={item} className={`text-[11px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-md ${chipClass}`} data-id="element-332" data-mp="1kmoy9afl0bz2">
          {item}
        </li>)}
    </ul>;
}